module.exports = __webpack_public_path__ + "static/media/better-addresses.82a989f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustrations/better-addresses.svg
// module id = 114
// module chunks = 0